import { HttpClient, HttpResponse } from '@angular/common/http';
import { IInsuranceItem } from '../models/insurance-item.model';
import { Injectable } from '@angular/core';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { ApplicationConfigService } from './application-config.service';
import { Observable, of } from 'rxjs';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { IMerchandise, Merchandise } from '../models/merchandise.model';

export type EntityResponseType = HttpResponse<IInsuranceItem>;
export type EntityArrayResponseType = HttpResponse<IInsuranceItem[]>;

@Injectable({ providedIn: 'root' })
export class MerchandiseService implements IBaryTableFetchService<IMerchandise> {
  protected resourceUrl = API_ENDPOINTS.MERCHANDISES;

  constructor(protected http: HttpClient, protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<IInsuranceItem[]>(this.resourceUrl, options);
  }

  updateMerchandiseName(merchandise: Merchandise): Observable<Merchandise> {
    return this.apiProvider.put<Merchandise>(`${this.resourceUrl}/name`, merchandise).pipe(mapAsBody);
  }

  updateMerchandiseNameByOffer(merchandise: Merchandise): Observable<Merchandise> {
    return this.apiProvider.put<Merchandise>(`${this.resourceUrl}/nameByOffer`, merchandise).pipe(mapAsBody);
  }

  // utilisation de put car nécessite de passer un objet et non un Id comme d'habitude
  delete(merchandise: Merchandise): Observable<Merchandise> {
    return this.apiProvider.put<Merchandise>(`${this.resourceUrl}/delete`, merchandise).pipe(mapAsBody);
  }

  fillDataToShow(entities: IMerchandise[]): Observable<IMerchandise[]> {
    return of(entities);
  }

  save(merchandise: Merchandise): Observable<Merchandise> {
    return this.apiProvider.put<Merchandise>(`${this.resourceUrl}`, merchandise).pipe(mapAsBody);
  }

  create(merchandise: IMerchandise): Observable<HttpResponse<IMerchandise>> {
    return this.apiProvider.post<IMerchandise>(this.resourceUrl, merchandise);
  }
}
